import { Response } from "../Model"
import client from "./client"

interface StaticFormData {
    education_level: Option[]
    marital_status: Option[]
    race: Option[]
    residential_status: Option[]
    bank: OptionBank[]
    monthly_income: Option[]
    occupation_group: Option[]
    employment_type: Option[]
}

interface Option {
    code: string
    value: string
}

interface OptionBank {
    code: string
    value: string
    status: status
    noOfDigits: string
}

export enum status {
    ACTIVE = `ACTIVE`,
    INACTIVE = `INACTIVE`
}

const getUserStaticData = () => {
    return client.get<Response<StaticFormData>>(`user/static-data`)
}

const emptyOption = (): Option => ({ code: ``, value: `` })

export default getUserStaticData
export type { StaticFormData, Option, OptionBank }
export { emptyOption }
